/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteTerritoryDtoBase
 * auto generated base class for the model RouteTerritoryDtoModel.
 */
export const RouteTerritoryDtoModelBase = ModelBase
  .named('RouteTerritoryDto')
  .props({
    __typename: types.optional(types.literal("RouteTerritoryDto"), "RouteTerritoryDto"),
    id: types.identifier,
    name: types.union(types.undefined, types.string),
    active: types.union(types.undefined, types.boolean),
    projectId: types.union(types.undefined, types.integer),
    geometryPolygon: types.union(types.undefined, types.null, types.frozen()),
    createdOn: types.union(types.undefined, types.string),
    updatedOn: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteTerritoryDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get name() { return this.__attr(`name`) }
  get active() { return this.__attr(`active`) }
  get projectId() { return this.__attr(`projectId`) }
  get geometryPolygon() { return this.__attr(`geometryPolygon`) }
  get createdOn() { return this.__attr(`createdOn`) }
  get updatedOn() { return this.__attr(`updatedOn`) }
}
export function selectFromRouteTerritoryDto() {
  return new RouteTerritoryDtoModelSelector()
}

export const routeTerritoryDtoModelPrimitives = selectFromRouteTerritoryDto().name.active.projectId.geometryPolygon.createdOn.updatedOn
